import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 使用规则配置下拉
export const getUseRuleConfigList = () =>
  request.post('/admin/config/systemSafeConfig/useRuleConfigPullEcho', null)

// 获取使用规则配置
export const getUseRuleConfig = (data?: any) =>
  request.post('/admin/config/systemSafeConfig/useRuleConfigEcho', data, jsonHeaderConfig)

// 保存使用规则配置
export const updateUseRuleConfig = (data?: any) =>
  request.post('/admin/config/systemSafeConfig/updateConfig', data, jsonHeaderConfig)

// ip列表
export const getLoginIpLimitList = (data?: any) =>
  request.post('/admin/loginConfig/ipWhitelist/page', data, jsonHeaderConfig)

//  新增ip
export const addLoginIpLimit = (data?: any) =>
  request.post('/admin/loginConfig/ipWhitelist/save', data, jsonHeaderConfig)

// 删除 ip
export const deleteLoginIpLimit = (data?: any) =>
  request.post('/admin/loginConfig/ipWhitelist/delete', data)

// 查询登录时限配置
export const getLoginTimeLimitConfig = () => request.get('/admin/loginConfig/loginLimit', null)

// 保存登录时限配置
export const updateLoginTimeLimitConfig = (data?: any) =>
  request.post('/admin/loginConfig/loginLimit/save', data, jsonHeaderConfig)
// 查询登录用户配置
export const getLoginUserConfig = () => request.get('/admin/loginConfig/userConfig', null)

// 保存登录用户配置-开关
export const updateLoginUserConfig = (data?: any) =>
  request.post('/admin/loginConfig/enabled', data)

// 保存登录用户配置-登录白名单
export const updateLoginUserConfigList = (data?: any) =>
  request.post('/admin/loginConfig/userWhitelist/save', data, jsonHeaderConfig)
